/**
 * Copyright (c) 2019, YUNXI. All rights reserved.
 * YUNXI PROPRIETARY/CONFIDENTIAL. Use is subject to license terms.
 */
/**
 * Date         : 2021-03-30 10:36:09
 * description  : 代码编辑器
 * author       : 天石
 */
import React from 'react';
import YxCodeMirror from 'hc-code-mirror';


export default class extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      value: ''
    }
  }

  handleChange = (val) => {
    this.setState({ value: val })
    const { onChange } = this.props
    onChange && onChange(val)
  }

  componentWillReceiveProps(nextProps) {
    if (this.state.value !== nextProps.value) {
      this.setState({ value: nextProps.value == null ? '' : nextProps.value })
    }
  }

  render() {
    const { inputParam, disabled, styleParam } = this.props;
    return (
      <YxCodeMirror
        value={this.state.value}
        onChange={this.handleChange}
        className='hc-code-mirror'
        style={styleParam}
        options={{
          mode: 'javascript',
          theme: 'default',
          readOnly: disabled,
          lineNumbers: !disabled,
          lint: !disabled,
          autoRefresh: !disabled,
          ...inputParam
        }}
      />
    )
  }
}


// WEBPACK FOOTER //
// ./src/yx-widget/component/YxInput/YxCode/yxCode.js